import SpinnerSmallIcon from "./spinner_small.js";
import SpinnerMediumIcon from "./spinner_medium.js";
export const AssetsMap = {
  small: SpinnerSmallIcon,
  medium: SpinnerMediumIcon
};